import { render, staticRenderFns } from "./NotificationButton.vue?vue&type=template&id=6db0e91c&scoped=true&"
import script from "./NotificationButton.vue?vue&type=script&lang=js&"
export * from "./NotificationButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationButton.vue?vue&type=style&index=0&id=6db0e91c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0e91c",
  null
  
)

export default component.exports